import { render, staticRenderFns } from "./cover-radom-drawer.vue?vue&type=template&id=844d6986"
import script from "./cover-radom-drawer.vue?vue&type=script&lang=js"
export * from "./cover-radom-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports